import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TimeSheetTaskWithoutDays } from '@app/time-sheet/models/time-sheet-task';

import { BehaviorSubject, catchError, defaultIfEmpty, filter, of, switchMap, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UploadTimeSheetService {
  private http = inject(HttpClient);

  private readonly refresh$ = new BehaviorSubject<{ year: number; month: number } | null>(null);

  refreshTasks(year: number, month: number) {
    this.refresh$.next({ year, month });
  }

  private readonly _tasks$ = this.refresh$.pipe(
    filter((r) => r !== null),
    switchMap((params) =>
      this.http
        .get<TimeSheetTaskWithoutDays[]>(`/timesheet/${params?.year}/${params?.month}/tasks`)
        .pipe(
          catchError(() => {
            return of([]);
          }),
          defaultIfEmpty([])
        )
    )
  );

  readonly tasks$ = this._tasks$;

  uploadTimeSheet(year: number, month: number, projectId: string, file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(`/timesheet/${year}/${month}/${projectId}/upload`, formData).pipe(
      tap(() => {
        this.refreshTasks(year, month);
      })
    );
  }
}
